import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SectionHeader, Switch, Text } from "@pentabd/ui";

import {
  InputDateControllerRow,
  InputTextAreaRow,
  InputTextRow,
  MultiFileRow,
} from "@components";

import {
  DISCIPLINE,
  DisciplineFormDataType,
} from "@validations/HRM/employee/disciplineValidation";

type Props = {
  isSuspend: boolean;
  onIsSuspend: (data: boolean) => void;
};

export const DisciplineProsecutionForm = ({
  isSuspend,
  onIsSuspend,
}: Props) => {
  const { t } = useTranslation();

  const {
    control,
    register,
    setValue,
    formState: { errors },
  } = useFormContext<DisciplineFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <SectionHeader title={t("EMPLOYEE.DISCIPLINE.FORM.LABEL")} />
      <InputTextRow
        register={{ ...register(DISCIPLINE.REASON_FOR_PUNISHMENT) }}
        label="EMPLOYEE.DISCIPLINE.FORM.REASON_FOR_PUNISHMENT"
        error={errors}
        required
      />
      <InputTextAreaRow
        register={{ ...register(DISCIPLINE.PUNISHMENT_DETAILS) }}
        label="EMPLOYEE.DISCIPLINE.FORM.PUNISHMENT_DETAILS"
        error={errors}
        required
      />
      <InputDateControllerRow
        label="EMPLOYEE.DISCIPLINE.FORM.DATE"
        control={control}
        register={{ ...register(DISCIPLINE.DATE) }}
        errors={errors}
        name={DISCIPLINE.DATE}
        required
      />

      <div>
        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" size="sm" color="title">
              {t("EMPLOYEE.DISCIPLINE.FORM.IS_SUSPEND.LABEL")}
            </Text>
          </div>
          <div className="col-lg-7 d-flex">
            <Switch
              id={DISCIPLINE.IS_SUSPEND}
              {...register(`${DISCIPLINE.IS_SUSPEND}`)}
              checked={isSuspend}
              onChange={(e) => {
                e.target.checked ? onIsSuspend(true) : onIsSuspend(false);

                setValue(DISCIPLINE.IS_SUSPEND, e.target.checked);
              }}
              size="sm"
              controlling
            />
            <Text
              weight="bold"
              color="primary"
              component="h4"
              sizeType="display"
              className="ms-5"
            >
              {isSuspend ? "Yes" : "No"}
            </Text>
          </div>
        </div>

        {isSuspend && (
          <div className="d-flex flex-column gap-8 mt-12">
            <InputDateControllerRow
              label="EMPLOYEE.DISCIPLINE.FORM.SUSPEND_START_DATE"
              control={control}
              register={{ ...register(DISCIPLINE.SUSPEND_START_DATE) }}
              errors={errors}
              name={DISCIPLINE.SUSPEND_START_DATE}
              required={isSuspend}
            />
            <InputDateControllerRow
              label="EMPLOYEE.DISCIPLINE.FORM.SUSPEND_END_DATE"
              control={control}
              register={{ ...register(DISCIPLINE.SUSPEND_END_DATE) }}
              errors={errors}
              name={DISCIPLINE.SUSPEND_END_DATE}
              required={isSuspend}
            />
          </div>
        )}
      </div>

      <InputTextRow
        register={{ ...register(DISCIPLINE.REMARKS) }}
        label="EMPLOYEE.DISCIPLINE.FORM.REMARKS"
        error={errors}
        required
      />
      <MultiFileRow
        name="document"
        control={control}
        setValue={setValue}
        register={register}
        error={errors}
        fileDetails={["memorialNo"]}
      />
    </div>
  );
};
